module.exports = "/complete_profile-871d28ec08d46a0b1a6f1f3f45b9d48e.svg";